export enum ConditionalOperator {
  EQ = 'EQ',
  NEQ = 'NEQ',
  GT = 'GT',
  GE = 'GE',
  LT = 'LT',
  LE = 'LE',
  CONTAINS = 'CONTAINS',
  ONE_OF = 'ONE_OF',
  DEFINED = 'DEFINED',
  UNDEFINED = 'UNDEFINED',
  HAS_VALUE = 'HAS_VALUE',
  NO_VALUE = 'NO_VALUE',
  NOT_HAS_VALUE = 'NOT_HAS_VALUE',
  ALL_KEYS_ARE_EMPTY = 'ALL_KEYS_ARE_EMPTY',
  NOT_ALL_KEYS_ARE_EMPTY = 'NOT_ALL_KEYS_ARE_EMPTY',
  NOT_CONTAINS = 'NOT_CONTAINS'
}
